export enum NOTIFICATION_TYPE {
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Error = 'error'
}